import "./ButtonLarge.css";

export interface Button1Props {
  title?: string;
  onClick?: () => void;
  className?: string;
  mode?: "white" | "black";
  isSmall?: boolean;
  Accent?: boolean;
  loading?: boolean;
}

export const ButtonLarge = ({
  title,
  onClick,
  className = "",
  mode = "white",
  isSmall = false,
  Accent = false,
  loading = false,
}: Button1Props) => {
  return (
    <div
      className={`${className} ${mode === "white" && "button1"} ${mode === "black" && "button2"} ${isSmall && "type-small"} ${Accent && "accent_style"} ${loading && "loading"}`}
      onClick={loading ? undefined : onClick ? onClick : () => {}}
    >
      {loading ? <span className="spinner" /> : title}
    </div>
  );
};
